'use strict'

const moduleConfig = require('../utils/module-config')

module.exports = (arg) => {
  const send = moduleConfig(arg)

  return {
    net: require('./net')(send),
    sys: require('./sys')(send),
    cmds: require('./cmds')(send)
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/diag/index.js
// module id = 338
// module chunks = 0